import React from 'react';
import { DollarSign, CreditCard, Home } from 'lucide-react';
import { Button } from './ui/button';

const ProcessSection = () => {
  const steps = [
    {
      icon: DollarSign,
      title: "Invest $500,000",
      description: "Choose a U.S. Visa project and invest $500,000 in a government approved regional center."
    },
    {
      icon: CreditCard,
      title: "Receive Greencard",
      description: "Receive your conditional green card in as little as 120 days*. Move to the U.S. with your eligible family members."
    },
    {
      icon: Home,
      title: "Receive Permanent Residency & Repayment of Investment",
      description: "After USCIS and Project requirements have been satisfied, the investor should anticipate Permanent U.S. Residency for the investor and their eligible family, and ultimately the repayment of their investment."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[#c94a4a] text-center text-sm uppercase tracking-wider mb-2">
          Your Path to Citizenship
        </p>

        {/* Process Steps */}
        <div className="relative mt-16">
          {/* Timeline Line */}
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-gray-300"></div>

          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => {
              const IconComponent = step.icon;
              return (
                <div key={index} className="relative text-center">
                  {/* Icon Circle */}
                  <div className="relative z-10 w-16 h-16 mx-auto mb-6 bg-white border-2 border-[#c94a4a] rounded-full flex items-center justify-center">
                    <IconComponent className="w-8 h-8 text-[#c94a4a]" />
                  </div>
                  
                  {/* Vertical Line from Icon */}
                  <div className="hidden md:block absolute top-16 left-1/2 w-0.5 h-8 bg-gray-300 -translate-x-1/2"></div>

                  <h3 className="text-[#1a3a5c] text-lg font-bold mb-3 mt-8">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center mt-12">
          <Button
            onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="border-[#1a3a5c] text-[#1a3a5c] hover:bg-[#1a3a5c] hover:text-white px-8 py-3 rounded font-medium"
          >
            Begin Your Investment Journey
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
